@if (visible) {
  <div class="loading-indicator">
    <mat-progress-spinner style="margin:0 auto;" mode="indeterminate"></mat-progress-spinner>
  </div>
}